export default __webpack_public_path__ + "static/media/reporting-empty.244106ea.png";